import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useAuth } from '../../authContext.js';
import { useImpersonatedUserStorage } from '../useImpersonatedUserStorage.js';
import { useSelectedCompanyStorage } from '../useSelectedCompanyStorage.js';
// Selects the given company, or clears the selection without one. Selecting a company ends the impersonation, in the
// storage too, so no tab restores both.
export const useSelectCompany = () => {
    const { forgetSelectedCompany, storeSelectedCompany } = useSelectedCompanyStorage();
    const { forgetImpersonatedUser } = useImpersonatedUserStorage();
    const { setImpersonatedUser, setSelectedCompany } = useAuth();
    return useCallbackRef((company, temporaryAccessExpiresAt = null) => {
        if (company) {
            forgetImpersonatedUser();
            setImpersonatedUser(null);
            storeSelectedCompany(company, temporaryAccessExpiresAt);
        }
        else {
            forgetSelectedCompany();
        }
        setSelectedCompany(company, temporaryAccessExpiresAt);
    });
};
